<template>
  <div class="attachment">
    <div v-if="emailAttachment">
      <div class="text-right mb-3">
        <a
          :href="dataUri"
          class="attachment-download"
          :download="name"
          type="application/octet-stream"
          >Download <i class="far fa-download"></i
        ></a>
      </div>
      <object class="preview" :data="dataUri" :type="mimeType" :name="name"
        >Vorschau nicht verfügbar</object
      >
    </div>
    <span v-else>Lade Anhang...</span>
  </div>
</template>

<script>
import gql from "graphql-tag";
export default {
  props: ["mimeType", "name", "emailId"],
  computed: {
    dataUri: {
      get() {
        if (this.uriCache) {
          return this.uriCache;
        } else {
          if (this.emailAttachment) {
            this.uriCache = URL.createObjectURL( // eslint-disable-line
              this.base64toBlob(this.emailAttachment.body, this.mimeType)
            ); // eslint-disable-line
            return this.uriCache;
          } else {
            return "javascript:;";
          }
        }
      },
      set(value) {
        this.uriCache = value;
      }
    }
  },
  methods: {
    base64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  },
  apollo: {
    emailAttachment: {
      query: gql`
        query EmailAttachment($emailId: Int!, $name: String!) {
          emailAttachment(emailId: $emailId, name: $name) {
            emailId
            name
            mimeType
            body
          }
        }
      `,
      variables() {
        return {
          name: this.name,
          emailId: this.emailId
        };
      }
    }
  }
};
</script>

<style scoped>
.attachment object {
  width: 100%;
}

.preview {
  min-height: 500px;
}
</style>
